import { types } from "../../../types/types";
import { fetchConToken } from "../../../helpers/fetch";
import { startSpinner, finishSpinner } from "../../ui/spinner";
import { handleErrorApi } from "../../../helpers/randoms";
import { startAlerta } from "../../ui/alertas";
import { filter, remplazarPorTildeASinTilde } from "../../../helpers/Buscador";

export const fetchModulos = (textoBuscado="") => async (dispatch) => {
    dispatch({ type: types.abmModulosTraerStart });

    try {
        const response = await fetchConToken(`Modulos`);
        let body = await response.json();
        if (textoBuscado !== "") {
            body = body.filter(n => filter(remplazarPorTildeASinTilde(n.descripcion), remplazarPorTildeASinTilde(textoBuscado)))
        }
        if (response.ok) {
            dispatch({
                type: types.abmModulosTraerSuccess,
                payload: body
            });
        } else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar los modulos.", "Ha ocurrido un error. Intente nuevamente")
        dispatch({ type: types.abmModulosTraerError });
    }
};

export const guardarModulo = (idModulo, datos, handleAfter) => async (dispatch) => {
    try {
        dispatch(startSpinner());

        let response;
        if(idModulo){
            response = await fetchConToken(`Modulos/${idModulo}`, datos, "PUT");
        }else{
            response = await fetchConToken(`Modulos`, datos, "POST");
        }
        
        const body = await response.json();

        if (response.ok) {
            handleAfter()
            dispatch(startAlerta("Modulo guardado correctamente", 'success', 'Comando Exitoso'))
            dispatch(finishSpinner());
            dispatch(fetchModulos());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al guardar un nuevo modulo.", "Ha ocurrido un error. Intente nuevamente")
    }
};

export const eliminarModulo = (idModulo) => async (dispatch) => {
    try {
        dispatch(startSpinner());

        const response = await fetchConToken(`Modulos/${idModulo}`, '', "DELETE");
        const body = await response.json(); 

        if(response.ok){
            dispatch(startAlerta("Modulo eliminado correctamente", 'success', 'Comando Exitoso'))
            dispatch(finishSpinner());
            dispatch(fetchModulos());
        }else{
            throw body; 
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Modulo el motivo de baja.", "Ha ocurrido un error. Intente nuevamente")
    }
};
